import React from 'react'
import { Link } from 'react-router-dom'

function FavoriteCard(props) {
  return (
    <div className="card card-main">
      <img
        src={props.artwork.imageUrl}
        className="card-img-top img-fluid"
        alt={props.artwork.thumbnail.alt_text}
      />
      <div className="card-body">
        <h5 className="card-title">{props.artwork.title}</h5>
        {
          props.artwork.artist_title ? 
            <p>{props.artwork.artist_title}</p>
            :
            <p>{props.artwork.artist_display}</p>              
        }
        <div className="row">
          <div className="col-6">
            <Link
              to={{ pathname: `/artworks/${props.artwork.id}` }}
              className="stretched-link"
            ></Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FavoriteCard